import { render, staticRenderFns } from "./business_experience.vue?vue&type=template&id=6f8487b6&"
import script from "./business_experience.vue?vue&type=script&lang=js&"
export * from "./business_experience.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports